import Vue from 'vue';

const success = (context, response, checkingIndex, checkoutIndex, memberId) => {
  for(let i = 0; i < checkingIndex.length; i++) {
    context.bookingsCheckings[checkingIndex[i]].assigned_to_checking = memberId;
    context.bookingsCheckings[checkingIndex[i]].checking_assign = response.data.assign;
    context.bookingsCheckings[checkingIndex[i]].checking_assign_status = response.data.assigned_status;
  }

  for(let j = 0; j < checkoutIndex.length; j++) {
    context.bookingsCheckouts[checkoutIndex[j]].assigned_to_checkout = memberId;
    context.bookingsCheckouts[checkoutIndex[j]].checkout_assign = response.data.assign;
    context.bookingsCheckouts[checkoutIndex[j]].checkout_assign_status = response.data.assigned_status;
  }
  context.statusCounts = {
    toBeAssigned: 0,
    assigned: 0,
    done: 0,
    cleaningFast: 0,
    cancelled: 0
  };
  context.calculateCounts();
};

const failed = (context, error) => {

};

export default (context, data, checkingIndex, checkoutIndex) => {
  return Vue.$http.post('bookings/assign-member-to-checked', data).
    then(response => {
     if(response && response.status === 200) {
       success(context, response, checkingIndex, checkoutIndex, data.member);
     }
  }).catch(error => {
    failed(context, error);
  });
}




// WEBPACK FOOTER //
// ./src/app/services/booking/assignMemberToChecked.js